import Vue from 'vue'
import VueI18n from 'vue-i18n'

import errorEN from '@/assets/locale/error/en.json'
import errorTH from '@/assets/locale/error/th.json'
import menuEN from '@/assets/locale/menu/en.json'
import menuTH from '@/assets/locale/menu/th.json'
import modalEN from '@/assets/locale/modal/en.json'
import modalTH from '@/assets/locale/modal/th.json'

Vue.use(VueI18n)

const messages = {
  en: {
    menu: menuEN,
    modal: modalEN,
    error: errorEN
  },
  th: {
    menu: menuTH,
    modal: modalTH,
    error: errorTH
  }
}

Vue.config.productionTip = false

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})
